import type { AdminProduct } from '../../api/group/groupAdminApiSlice';
import type { UseCase } from '../../utils/useCases';

/**
 * An object is assigned to a PRODUCT, and the product is the service (PO,
 * 2026-10-08, #3167): the room form no longer asks for a service and then for
 * a product — the service follows from the product. Today "service" is still
 * the use case; the product's category carries it (ADR-0026 §G).
 */

/**
 * The room use case a product fulfils, among the ones the tenant may create —
 * or null. Read from `useCase` with the compartment fallback for
 * object-minted products whose `use_case` is null, compared
 * case-insensitively (API-values rule).
 */
export const roomUseCaseOfProduct = (
    product: Pick<AdminProduct, 'useCase' | 'compartmentTypes'> | undefined,
    allowed: readonly UseCase[],
): UseCase | null => {
    const useCase = (product?.useCase ?? product?.compartmentTypes?.[0] ?? '').toLowerCase();
    return (allowed as readonly string[]).includes(useCase) ? useCase as UseCase : null;
};

/** The products a new room can be created into: those of an allowed room use case. */
export const productsForNewRoom = <P extends Pick<AdminProduct, 'useCase' | 'compartmentTypes'>>(
    products: P[],
    allowed: readonly UseCase[],
): P[] => products.filter((product) => roomUseCaseOfProduct(product, allowed) !== null);
